import { render, staticRenderFns } from "./SeveritySelector.vue?vue&type=template&id=09288ff1&"
import script from "./SeveritySelector.vue?vue&type=script&lang=js&"
export * from "./SeveritySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports